import React from 'react';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Solution } from './components/Solution';
import { Audience } from './components/Audience';
import { Checkout } from './components/Checkout';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-body selection:bg-brand-gold/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Story data-id="element-3" />
        <Solution data-id="element-4" />
        <Audience data-id="element-5" />
        <Checkout data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}